import { createStore, createLogger } from 'vuex'
import * as getters from './getters'
import * as actions from './actions'
import mutations from './mutations'

export default createStore({
  state: {
    theme: localStorage.getItem('theme') || 'light',
    company: { name: '', logo: '', logoDark: '', uiStyle: 'classic', short: '', backendMode: true, build: '', brand: '', favicon: '', legalName: '', website: '', theme: {}, vapidPublicKey: '' },
    isbackend: false,
    client: {
      name: null,
      organization: { id: 0, code: '' },
      organizations: [], /* [ { id: 1, code: A' },{ id: 2, code: 'B' } ] */
      role: 0,
      authenticated: false,
      timestamp: new Date(),
      planType: 'NONE',
      co2ReportIncluded: false,
      usageReportIncluded: false,
      dashboardIncluded: false
    },
    errorinfo: {
      origin: '',
      message: ''
    },
    errorflag: false,
    running: false,
    users: [/* {id, created, username, email, firstName, lastName, password, userroleid} */],
    organizations: [/* {id, code, name} */],
    facilities: [/* {id, organizationid, name, description, location} */],
    cdcdevices: [/* id, facilityid, apikey, lastseen, serialnumber, notificationstatus, status */],
    cdcsensors: [/* id, cdcdeviceid, ... */],
    sensorevents: [/* id, cdcsensorid, sensoralerteventcode, sensoralertstatuscode, ... */],
    cdcdatavalues: [/* id, cdcdeviceid, ..., values */],
    roles: [/* {id, code, name} */],
    userpushtokens: [/* {id, userid, lastseeen, model, token, vendor} */],
    collections: [/* id, hexaddress, name, serialnr, sensortype, created, json */],
    dailyTotals: [/* id, startofday, lastupdate, cdcsensorid, externalsensorid, factor, systempart, valuetypepulse, valuetypetotal, value, type, unit, typestring, meterinfo, obis, externalfacilityid */],
    sensorAggregations: [/* aggregations */],
    sensorTotalScope: [/* totals: [ startdate, enddate, cdcsensorid, externalsensorid, total, co2e, type, unit, typestring, sensorName, facilityName, meterinfo, obis ] */],
    meterPlan: {/* facilityId, facilityName, dates, slackDays, rows: [ key, hexaddress, sensorName, serialnr, meterinfo, unit, meta, readings ] */},
    supplyContracts: [/* { id, contractName, companyName, co2e, scope, basePrice, unitPrice, isDynamic } */]
  },
  getters,
  actions,
  mutations,
  plugins: process.env.NODE_ENV !== 'production'
    ? [createLogger()]
    : []
})
